import { createAction, props } from "@ngrx/store";
export const moduleId = createAction('[module-info] ModuleId', props());
export const moduleChanged = createAction('[module-info] ModuleChanged', props());
